const landingPageBuilderModule = {
  state: {},
  getters: {
    // TODO: combine 'getHosted' into one getter
    getHostedLogoUrl(state) {
      return () => state.logo_url;
    },
    getHostedRedirectUrl(state) {
      return () => state.settings.redirect_url;
    },
    getHostedTagLine(state) {
      return () => state.settings.tag_line;
    },
    getHostedBusinessName(state) {
      return () => state.settings.business_name;
    },
    getHostedMerchantUUID(state) {
      return () => state.settings.merchant_uuid;
    },
  },
  mutations: {
    updateState(state, payload) {
      const newState = { ...state, ...payload };
      Object.assign(state, newState);
    },
    clearState(state) {
      const keys = Object.keys(state);
      // keeping vuex state object (which is tracked by vuex), but deleting its keys to clear it
      keys.forEach((key) => {
        delete state[key]; // eslint-disable-line no-param-reassign
      });
    },
  },
  actions: {
    setNewState({ commit }, payload) {
      commit('updateState', payload);
    },
    clearLandingPageState({ commit }) {
      commit('clearState');
    },
  },
};
export default landingPageBuilderModule;
